module.exports = "<div class=\"row\">\n<img class='pageNotFound' [src]='pageNotFound'>\n</div>"